<template>
  <td class="align-middle">
    <div v-if="id" @click="copyToCb($refs['customerId'], id)" class="ellipsis customerId cursorPointer" :title="id">
      <span ref="customerId">{{ id }}</span>
    </div>
  </td>
</template>

<script>
import { useCopy } from '@/use/copy'

export default {
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  setup() {
    const { copyToCb } = useCopy()
    return { copyToCb }
  }
}
</script>

<style lang="scss" scoped>
.customerId {
  width: 50px;
}
</style>
